<template>
  <!-- 实训中心-关联租户界面 -->
  <div class="associated-tenant">
    <div class="tenant-header">
      <span class="tenant-header-title" @click="onAddTenant">添加租户 <i class="el-icon-circle-plus-outline"></i></span>
      <div class="tenant-header-right">
        <span @click="batchRemove()"><i class="icon-delete"></i>批量移除</span>
        <search-box :placeholderName="'请输入租户名称'" :buttonShow="true" @onSearchKey="onSearchTenant"></search-box>
      </div>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{background:'#E7F1FF',color:'#606266'}"
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      stripe
      border>
      <el-table-column type="selection" align="center" width="55"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
      <el-table-column prop="tenantName" label="租户名称" align="center"></el-table-column>
      <el-table-column prop="tenantDescribe" label="租户描述" align="center"></el-table-column>
      <el-table-column prop="tenantType" label="类别" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.tenantType == 10 ? '内置租户' : '普通租户' }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="batchRemove(scope.row.relationId)" type="text" size="small">
            移除
          </el-button>
        </template>
      </el-table-column>
      <!-- ele 暂无数据插槽 -->
      <template slot="empty">
        <div class="noData">当前课程实训还未关联租户哦，开始添加吧~</div>
      </template>
    </el-table>

    <div class="popup-list">
      <!-- 添加租户 -->
      <gat-popup
        :class="['popup-addTenant', popupActive === 'addTenant' ? 'on' : 'off']"
        :title="'添加租户'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="addTenantProject"
      >
        <template v-slot:content>
          <div class="popup-addTenant-centent">
            <div class="centent-left">
              <div class="search-tenant popup-border-color">
                <el-input
                  placeholder="请输入租户名称"
                  v-model.trim="searchAddTenantName"
                  @keyup.enter.native="onSearchAddTenant"
                >
                  <i slot="suffix" class="icon-search-box" @click="onSearchAddTenant">
                    <span class="el-icon-search"></span>
                  </i>
                </el-input>
              </div>
              <div class="tenant-list popup-border-color">
                <ul>
                  <li v-for="(item, index) in tenantList" :key="index">
                    <i :class="[item.isRelation==1?'el-icon-success':'icon-circular']" @click="onSelectTenant(item.tenantId)"></i>
                    <span class="span-tenantName">{{item.tenantName}}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="centent-right popup-border-color">
              <div class="centent-right-header">
                <span>{{tenantList2&&tenantList2.length!==0 ? `已选择${tenantList2.length}个租户`:'请选择需要添加的租户'}}</span>
                <span @click="onDeselectAllTenant">全部清除</span>
              </div>
              <div class="tenant-list">
                <ul>
                  <li class="tenant-list-li" v-for="(item, index) in tenantList2" :key="index">
                    <span>{{item.tenantName}}</span>
                    <i class="el-icon-close" @click="onDeselectTenant(item.tenantId)"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 移除 -->
      <gat-popup
        :class="['popup-delete popup-remove', popupActive === 'remove' ? 'on' : 'off']"
        :title="''"
        :primary-button="'移除'"
        @cancel="cancelPopup"
        @confirm="removeProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">{{popupRemoveText.title}}</span>
            </div>

            <div class="content">{{popupRemoveText.content}}</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'

import SearchBox from '@/components/common/SearchBox.vue'
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'

export default {
  name: 'associatedTenant',
  components: {SearchBox, GatPopup, IconInfoHelp},
  props: {
    curriculumId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      tableData: [],
      popupActive: '',
      tenantList: [], // 关联租户弹窗-左侧组织租户列表
      tenantList2: [], // 关联租户弹窗-选中租户列表
      searchTenantName: '', // 表格关联租户-搜索
      searchAddTenantName: '', // 关联租户弹窗-搜索
      searchUserState: '', // 关联租户弹窗-搜索租户状态
      relationId: '', // 删除已关联课程的租户（单）
      selectTenantList: [], // 删除已关联课程的租户（批）
      popupRemoveText: {
        title: '确定移除租户吗？',
        content: '移除后该租户将看不到本课程！',
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
    }
  },
  watch: {},
  created() {
    this.getTenantRelationByCurriculumId()
  },
  methods: {
    // 搜索
    onSearchTenant(key) {
      this.searchTenantName = key
      // 查询组织列表
      this.getTenantRelationByCurriculumId()
    },
    // 根据课程id查询租户关联信息
    getTenantRelationByCurriculumId() {
      let data = {
        curriculumId: this.curriculumId,
        tenantName: this.searchTenantName,
      }
      PROJECTS.getTenantRelationByCurriculumId(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.tableData = res.data || []
          this.$emit('getTableData', this.tableData)
        } else {
          this.tableData = []
        }
      }).catch((err) => {
        console.log(err)
        this.tableData = []
      })
    },

    // 添加租户弹窗
    onAddTenant() {
      this.popupActive = 'addTenant'
      this.tenantList2 = []
      // 根据课程id查询租户列表
      this.getTenantByCurriculumId()
    },
    // 关联租户搜索
    onSearchAddTenant() {
      if (this.searchUserState !== this.searchAddTenantName) {
        this.searchUserState = this.searchAddTenantName
        this.getTenantByCurriculumId(1)
      }
    },
    
    // 根据课程id查询租户列表
    getTenantByCurriculumId(searchType) {
      let data = {
        curriculumId: this.curriculumId,
        tenantName: this.searchAddTenantName,
      }
      return PROJECTS.getTenantByCurriculumId(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.tenantList = res.data
          if (searchType == 1) { // 搜索勾选租户处理
            this.tenantList.forEach(item => item.isRelation = 0)
            this.tenantList.forEach(item => {
              this.tenantList2.forEach(i => {
                if (item.tenantId === i.tenantId) {
                  item.isRelation = 1
                }
              });
            });
          } else {// 初始勾选租户处理
            this.tenantList.forEach(item => {
              if (item.isRelation == 1) {
                let flng = this.tenantList2.every(i => i.tenantId !== item.tenantId)
                if (flng) {
                  this.tenantList2.push(item)
                }
              }
            });
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    // 确认添加租户-保存课程与租户的关联关系
    addTenantProject() {
      let data = {
        curriculumId: this.curriculumId,
        tenantInfos: []
      }
      this.tenantList2.forEach(item => {
        data.tenantInfos.push({
          tenantId: item.tenantId, // 租户描述
          introduce: item.introduce, // 租户id
          tenantName: item.tenantName, // 租户名称
          type: item.type, // 租户类别：10为内置租户，20为普通租户
        })
      });

      PROJECTS.saveCurriculumAndTenant(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.$message.success('关联成功!')
          this.getTenantRelationByCurriculumId()
          this.cancelPopup()
        } else {
          this.$message.error(res.returnMsg)
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    // 选中添加租户
    onSelectTenant(id) {
      this.tenantList.forEach(item => {
        if (item.tenantId === id) {
          item.isRelation = item.isRelation == 1 ? 0 : 1
          if (item.isRelation == 1) {
            let flng = this.tenantList2.every(item => item.tenantId !== id)
            if (flng) {
              this.tenantList2.push(item)
            }
          } else {
            this.tenantList2.forEach((item, index) => {
              if (item.tenantId === id) {
                this.tenantList2.splice(index, 1)
              }
            });
          }
        }
      });
    },
    // 取消选中租户
    onDeselectTenant(id) {
      this.tenantList2.forEach((item, index) => {
        if (item.tenantId === id) {
          this.tenantList2.splice(index, 1)
        }
      });
      this.tenantList.forEach((item, index) => {
        if (item.tenantId === id) {
          item.isRelation = item.isRelation == 1 ? 0 : 1
        }
      });
    },
    // 清除所有选中租户
    onDeselectAllTenant() {
      this.tenantList2 = []
      this.tenantList.forEach((item, index) => {
        item.isRelation = 0
      });
    },
    
    // 选中的关联租户
    handleSelectionChange(val) {
      this.selectTenantList = val
    },

    // 移除关联的租户
    batchRemove(rowId) {
      if (rowId) { // 单删
        this.relationId = rowId || ''
        this.popupRemoveText.content = '移除后该租户将看不到本课程！'
        this.popupActive = 'remove'
      } else { // 批删
        if (this.selectTenantList.length !== 0) {
          this.popupRemoveText.content = '被移除的租户将看不到本课程！'
          this.popupActive = 'remove'
        } else {
          this.$message.warning('请勾选需要移除的租户!')
        }
      }
    },
    // 确认移除关联的租户
    removeProject() {
      if (this.relationId) {
        this.removeTenant() // 移除关联租户
      } else {
        this.batchRemoveTenant() // 批量删除关联租户
      }
    },
    deleteRemoveTenantReturn(res) {
      if (res && res.returnCode == 200) {
        this.$message.success('移除成功!')
        this.getTenantRelationByCurriculumId()
        this.cancelPopup()
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    // 移除关联租户
    removeTenant() {
      let data = {
        relationId: this.relationId
      }
      PROJECTS.deleteRelationByRelationId(data).then((res) => {
        this.deleteRemoveTenantReturn(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 批量删除关联租户
    batchRemoveTenant() {
      let data = {
        relationIds: []
      }
      this.selectTenantList.forEach(item => {
        data.relationIds.push(item.relationId)
      });
      PROJECTS.batchDeleteRelationByRelationId(data).then((res) => {
        this.deleteRemoveTenantReturn(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    
    // 取消弹窗
    cancelPopup() {
      this.relationId = ''
      // this.selectTenantList = []

      this.popupActive = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.associated-tenant {
  width: 100%;
  height: 100%;

  .tenant-header {
    height: 80px;
    background-color: #fff;
    border: 1px solid #e7edf8;
    box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    margin-bottom: 20px;
    .tenant-header-title {
      font-size: 14px;
      background-color: #4c88ff;
      border-radius: 5px;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 20px;
        margin-left: 10px;
      }
    }
    .tenant-header-right {
      display: flex;
      align-items: center;
      span {
        width: 117px;
        height: 36px;
        color: #4C88FF;
        font-size: 16px;
        border: 1px solid #4C88FF;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        cursor: pointer;
        .icon-delete {
          width: 16px;
          height: 16px;
          // background: url("../../../assets/images/trainingCenter/icon_delete.png") no-repeat center;
          background: url("~@/assets/images/trainingCenter/icon_delete.png") no-repeat center;
          background-size: 100% 100%;
          margin: 0 5px 4px 0;
        }
      }
    }
  }
  .el-table {
    border: 1px solid #e7edf8;
    box-shadow: 0px 4px 10px 0px rgba(109, 113, 171, 0.1);
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: rgba(231, 241, 255, 0.7);
  }

  .popup-list {
    .popup {
      z-index: 3;
    }
    .popup-addTenant,
    .popup-delete {
      &.off {
        display: none;
      }
    }
    .popup-addTenant {
      z-index: 9;
      &::v-deep .popup-inner {
        width: 934px;
        height: 500px;
        .popup-buttons {
          position: static;
          text-align: right;
          margin-right: 120px;
        }
      }
      &::v-deep .popup-head {
        color: #2B6CEB;
        font-weight: 700;
      }
      .popup-addTenant-centent {
        padding: 32px 20px;
        display: flex;
        justify-content: space-between;
        .popup-border-color {
          border: 1px solid #85B6FF;
          box-shadow: 0px 2px 8px 0px rgba(59, 135, 249, 0.1);
        }
        .centent-left {
          width: 400px;
          .search-tenant {
            height: 36px;
            margin-bottom: 2px;
            box-sizing: border-box;
            overflow: hidden;
            /deep/.el-input {
              margin-top: 0;
              height: 36px;
            }
            /deep/.el-input__inner {
              width: 100%;
              height: 100%;
              border: none;
            }
            .icon-search-box {
              font-size: 20px;
              // vertical-align: -15px;
              line-height: 36px;
              padding-right: 5px;
              cursor: pointer;
            }
          }
        }

        .centent-right {
          width: 400px;
          // height: 314px;
          height: 334px;
          font-size: 14px;
          .centent-right-header {
            height: 38px;
            border: 1px solid #D8E5FD;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 17px;
            span:first-child {
              color: #333333;
              font-weight: 700;
            }
            span:last-child {
              color: #fff;
              width: 73px;
              height: 26px;
              background: #4C88FF;
              border-radius: 3px;
              line-height: 26px;
              text-align: center;
              cursor: pointer;
            }
          }
          // .tenant-list {}
        }
        .tenant-list {
          height: 276px;
          padding: 10px 0px;
          overflow-x: hidden;
          overflow-y: auto;
          ul {
            li {
              // height: 30px;
              font-size: 16px;
              display: flex;
              align-items: center;
              padding: 5px 20px;
              i {
                width: 18px;
                height: 18px;
                box-sizing: border-box;
                cursor: pointer;
              }
              .icon-circular {
                border: 1px solid #BBBFD0;
                border-radius: 50%;
              }
              .el-icon-success {
                color: #3B87F9;
                font-size: 20px;
              }
              .el-icon-success:before {
                margin-left: -1px;
              }
              span {
                flex: 1;
              }
              .span-tenantName {
                margin-left: 10px;
              }
              &:hover {
                background: #EEF4FC;
              }
            }
            .tenant-list-li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .el-icon-close {
                color: #3B87F9;
                font-size: 20px;
                font-weight: 700;
              }
            }
          }
          /*修改滚动条样式*/
          &::-webkit-scrollbar{
            width: 6px;
            height: 10px;
          }
          &::-webkit-scrollbar-track{
            // background: rgb(239, 239, 239);
            background: #EEF4FC;
            border-radius: 2px;
          }
          &::-webkit-scrollbar-thumb{
            background: #3B87F9;
            border-radius:10px;
          }
          &::-webkit-scrollbar-thumb:hover{
            background: #3B87F9;
          }
          &::-webkit-scrollbar-corner{
            background: #179a16;
          }
        }
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
          margin-top: 25px;
        }
      }
      /deep/.popup-inner .popup-content {
        padding: 0 20px;
      }
    }
    .pop-select {
      width: 100%;
    }
    .pop-el-form {
      margin-top: 30px;
    }
  }
}
</style>